angular.module('7Shop.Core').service('SevenGamesMapper', function SevenGamesMapper() {
  return {
    VirtualGreyhoundRaces: 'GreyhoundRaces',
    VirtualHorseRaces: 'HorseRaces'
  };
});
